import crossy_road_detail from "../assets/image/crossy_road_small_detail.png"
import super_pet_detail from "../assets/image/super_pet_detail.png"
import pilot_training_detail from "../assets/image/pilot_training_detail.png"
import small_crocodile_detail from "../assets/image/small_crocodile_detail.png"
import doodle_jump_detail from "../assets/image/doodle_jump_detail.png"
import wake_up_santa_claus_detail from "../assets/image/wake_up_santa_claus_detail.png"
import danger_detail from "../assets/image/danger_detail.png"
import anyRead_detail from "../assets/image/anyRead_detail.png"
import SCweather_detail from "../assets/image/SCweather_detail.png"
import qtouch_small_detail from "../assets/image/qtouch_small_detail.png"
import Ski_Challenge_small_detail from "../assets/image/Ski_Challenge_small_detail.png"
import the_ancient_ore_small_detail from "../assets/image/the_ancient_ore_small_detail.png"

export default {
    data() {
        return {
            is_english: false,
            is_chinese: true,
            click_more: false,
            detail_info: {},
            detail_info_array: [
                {
                    image: crossy_road_detail,
                    title: "Crossy Road",
                    content_cn: "《天天过马路》是一款可以勾起你儿时记忆的经典“过马路”小游戏。 游戏中玩家将控制各种萌宠小怪在拥挤的街道横穿马路，同时要警惕道路上来往的车辆。面对这变幻莫测的场景，你还能完成这极限挑战吗？",
                    content_en: "\"Crossing the road every day\" is a classic \"crossing the road\" game that can remind your childhood memory. In the game, players will control all kinds of cute monsters to cross the road in the crowded street, and at the same time, be alert to the traffic on the road. Can you still face this unpredictable challenge?"
                },
                {
                    image: Ski_Challenge_small_detail,
                    title: "Ski Challenge",
                    content_cn: "《Ski Challenge》极具挑战性的休闲小游戏，人物从上而下滑雪，尽可能的避开护栏和其他障碍物。虽然玩法简单，但是对操作要求很高。赶紧来体验突破极限的快感吧。",
                    content_en: "\"Ski challenge\" is a challenging leisure game in which characters ski from top to bottom, avoiding guardrails and other obstacles as much as possible. Although the playing method is simple, but the operation requirements are very high. Come and experience the thrill of breaking through the limit."
                },
                {
                    image: the_ancient_ore_small_detail,
                    title: "The Ancient Ore",
                    content_cn: "传统型消除游戏，但是在玩法上稍有不同。通过移动一整行/列，来达到消除的目的。当然游戏中的爆炸效果做的也是相当炫丽。",
                    content_en: "Traditional elimination game, but in the play method is slightly different. By moving a whole row / column to achieve the purpose of elimination. Of course, the explosion effect in the game is also quite dazzling."
                },
                {
                    image: super_pet_detail,
                    title: "Super Pet",
                    content_cn: "《超级宠物》是经典三消游戏，通过按键上下左右选择来将同颜色三个及以上横竖相连进行消除， 当消除宠物超过三个以上时，将产生五角星特殊道具， 五角星可和同颜色宠物排在一起消除，并会引发特殊消除效果。深受玩家喜爱，百玩不厌。",
                    content_en: "\"Super pet\" is a classic three elimination game. Three or more colors of the same color are connected horizontally and vertically through the selection of buttons. When more than three pets are eliminated, special props of five pointed star will be generated. The pentagram star can be eliminated together with the pets of the same color, which will cause special elimination effect. Deeply loved by the players, never tired of playing."
                },
                {
                    image: pilot_training_detail,
                    title: "Pilot Training",
                    content_cn: "《Pilot Training》是一款飞行游戏，用户可以对自己的飞机外观进行自由组合。对搭配满意后，即可开始游戏，体验一下飞行员的感觉。",
                    content_en: "\"Pilot training\" is a flying game, users can freely combine their own aircraft appearance. After you are satisfied with the match, you can start the game and experience the feeling of the pilot."
                },
                {
                    image: small_crocodile_detail,
                    title: "Small Crocodile",
                    content_cn: "是一款忆旧游戏，时光荏苒，童年时光总是那么的美好。",
                    content_en: "Is a memory game, time flies, childhood is always so beautiful."
                },

                {
                    image: doodle_jump_detail,
                    title: "Doodle Jump",
                    content_cn: "《涂鸦跳跃》是一款富有趣味的技巧性的游戏，在游戏中玩家要让涂鸦弹簧小怪物不停地往上跳跃，在跳跃中要小心破碎的平台、移动的平台、不明怪兽等，途中有快速上升的火箭帮助你获取更高分数。已经突破了1000万次下载的大关。",
                    content_en: "\"Graffiti jump\" is a fun and skilful game. In the game, players should make graffiti spring monsters keep jumping up, and be careful of broken platforms, mobile platforms, unidentified monsters, etc. on the way, there are fast rising rockets to help you get higher scores. It has broken through the 10 million downloads."
                },

                {
                    image: wake_up_santa_claus_detail,
                    title: "Wake Up Santa Claus",
                    content_cn: "通过消除绿色隔板，使雪花下落，通过落下的雪花唤醒圣诞老人。雪花落下过程中拾取到的星星越多，奖励越丰厚。想要三星过关可是需要一定的智慧。",
                    content_en: "By eliminating the green partition, the snowflakes fall and wake up Santa Claus through the falling snowflakes. The more stars the snowflakes pick up in the process of falling, the richer the reward. It takes a certain amount of wisdom to get through Samsung."
                },

                {
                    image: danger_detail,
                    title: "Danger",
                    content_cn: "《Danger》通过左右移动鼠标或者触摸屏幕的左右来使人物左右移动，利用中间的弹簧，使人物飞起来，飞起过程中搜集星星，集齐星星即可过关",
                    content_en: "\"Danger\" makes the characters move left and right by moving the mouse left and right or touching the left and right of the screen. By using the spring in the middle, the characters can fly up. In the process of flying, they can collect stars and gather them to cross the border"
                },

                {
                    image: qtouch_small_detail,
                    title: "Qtouch",
                    content_cn: "Qtouch是Android辅助操控工具软件，集成系统中的各项功能操作，使智能手机操控更加方便、轻松、快捷",
                    content_en: "Qtouch is an Android auxiliary control tool software, which integrates various functions in the system to make smart phone control more convenient, easy and fast"
                },

                {
                    image: anyRead_detail,
                    title: "AnyRead",
                    content_cn: "目前AnyRead常年在越南泰国等地稳居下载与畅销榜前三，拥有近十万忠实付费用户，并建立了自己完整的内容供给生态，结合公司业务，不断拓展东南亚网络文学市场与培育优质内容创作者。",
                    content_en: "At present, anyread is in the top three of download and best-selling lists in Vietnam, Thailand and other places all year round. It has nearly 100000 loyal paying users, and has established its own complete content supply ecology. Combined with the company's business, it has continuously expanded the Southeast Asian network literature market and cultivated high-quality content creators."
                },

                {
                    image: SCweather_detail,
                    title: "SCweather",
                    content_cn: "一款使用简单，免费的天气预报，人性化设计，界面清新，可根据客户需求订做小部件，支持15天天气预报，天气预报精淮，数据源来自世界级权威气象站（AccuWeather与Weather Channel）。可查询全球超30000个城市气象数据，为您的生活出行保驾护航。与多个知名手机厂商合作，用户遍布东南亚、欧洲、非洲、美洲",
                    content_en: "A simple, free weather forecast, user-friendly design, fresh interface, can be customized according to customer needs, support 15 days weather forecast, weather forecast precision, data source from the world-class authoritative weather station (accuweather and weather channel). You can query the meteorological data of more than 30000 cities in the world to escort your life and travel. We cooperate with many famous mobile phone manufacturers, and our customers are all over Southeast Asia, Europe, Africa and America"
                },
            ],
            top: 0
        }
    },
    watch: {
        click_more(val) {
            if (val) {
                this.top = document.documentElement.scrollTop;
                document.getElementsByClassName("wrap")[0].style.top = -this.top + "px";
            } else {
                setTimeout(() => {
                    window.scrollTo({
                        top: this.top,
                    })
                }, 0);
            }
        }
    },
    mounted() {
        /*监听滚动函数*/
        window.addEventListener("scroll", this.scrollFun);
        this.scrollFun();
    },
    methods: {
        scrollFun() {
            this.$animate(document.getElementsByClassName("img_top")[0], "myFadeinUp");
            this.$animate(document.getElementsByClassName("slogan")[0], "fadeInUp");
            this.$animate(document.getElementsByClassName("img_bottom")[0], "fadeInUp");
            // this.$animate(document.getElementsByClassName("game_list")[0], "fadeInUp");
            this.$animate(document.getElementsByClassName("big_title")[0], "fadeInUp");
            this.$animate(document.getElementsByClassName("game_class")[0], "fadeInUp");
            // this.$animate(document.getElementsByClassName("game_content ")[0], "fadeInUp");
            // this.$animate(document.getElementsByClassName("tool")[0], "fadeInUp");
            this.$animate(document.getElementsByClassName("left_info")[0], "fadeInUp");
            this.$animate(document.getElementsByClassName("service_data_title")[0], "fadeInUp");
            this.$animate(document.getElementsByClassName("service_data")[0], "fadeInUp");
            this.$animate(document.getElementsByClassName("contact_us")[0], "fadeInUp");

            document.getElementsByClassName("title").forEach(item => {
                this.$animate(item, "fadeInUp");
            });
            document.getElementsByClassName("content").forEach(item => {
                this.$animate(item, "fadeInUp");
            });
            document.getElementsByClassName("more").forEach(item => {
                this.$animate(item, "fadeInUp");
            });
            document.getElementsByClassName("image_animation").forEach(item => {
                this.$animate(item, "fadeInUp");
            });
        },
        logo_btn(){
            location.reload();
        },
        chinese_btn() {
            this.is_chinese = true;
            this.is_english = false;
        },
        english_btn() {
            this.is_chinese = false;
            this.is_english = true;
        },
        // 点击更多的时候
        more_btn(num) {
            this.click_more = true;
            this.detail_info = this.detail_info_array[num];
        },
        // 点击关闭icon的时候
        close_btn() {
            this.click_more = false;
        },
        silution_btn() {

            window.scrollTo({
                top: 38,
                behavior: "smooth"
            })
        },
        product_btn() {
            window.scrollTo({
                top: this.$refs['product'].offsetTop - 20,
                behavior: "smooth"
            })
        },
        service_btn() {
            window.scrollTo({
                top: this.$refs['service'].offsetTop - 20,
                behavior: "smooth"
            })
        },
        contact_btn() {
            window.scrollTo({
                top: this.$refs['contact_us'].offsetTop - 20,
                behavior: "smooth"
            })
        },


    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.scrollFun);
    }

}